<!-- 
*****************************************************************************
**                                                                         **
** Copyright (c) 2012-2024, Tyker Technology BV                            **
** All rights reserved.                                                    **
**                                                                         **
** This software is the confidential and proprietary information of        **
** Tyker Technology BV. Unauthorized copying or disclosure of this file,   **
** via any medium is strictly prohibited. This file is only available to   **
** authorized individuals with the permission of the copyright holders.    **
** If you encounter this file and do not have permission, please contact   ** 
** the copyright holders and delete this file.                             **
**                                                                         **
***************************************************************************** 
-->

<template>
  <v-dialog
    v-model="dialog"
    persistent
    id="createTask"
    width="1000px"
    :fullscreen="$vuetify.breakpoint.xsOnly"
  >
    <TaskCreateInfo
      v-if="!current && !milling"
      v-on="handlers"
    />
    <TaskCreateCurrent
      v-if="current"
      v-on="handlers"
    />
    <TaskCreateMilling
      v-if="milling"
      v-on="handlers"
    />
  </v-dialog>
</template>

<script>
import TaskCreateInfo from "./TaskCreateInfo";
import TaskCreateCurrent from "./TaskCreateCurrent";
import TaskCreateMilling from "./TaskCreateMilling";

export default {
  components: {
    TaskCreateInfo,
    TaskCreateCurrent,
    TaskCreateMilling,
  },
  props: {},
  data() {
    return {
      dialog: true,
      current: false,
      milling: false,
      handlers: {
        close: this.onClose,
        current: this.showCurrent,
        milling: this.showMilling,
        taskCreated: this.onTaskCreated,
        openTask: this.onOpenTask,
      },
    };
  },
  mounted: function () {
    console.log("CreateTask mounted");
  },
  computed: {},
  watch: {},
  methods: {
    createtask() {
      this.name = "";
    },
    showCurrent() {
      this.current = true;
    },
    showMilling() {
      this.milling = true;
    },
    onClose() {
      this.$emit("close");
    },
    onTaskCreated() {
      this.$emit("taskCreated");
    },
    onOpenTask(taskId) {
      this.$emit("openTask", taskId);
    },
  },
};
</script>

<style scoped>
#createTask {
  max-width: 1000px;
}
</style>
